import React from "react";
import { IntlProvider } from "react-intl";
import { DEFAULT_LOCALE } from "../constants/locales";
import messages from "../config/i18n/messages";
import flattenObject from "../utils/flattenObject";
/**
 * Wrap component with IntlProvider
 */ var withIntl = function(WrappedComponent) {
    return function(props) {
        return /*#__PURE__*/ React.createElement(IntlProvider, {
            locale: DEFAULT_LOCALE,
            messages: flattenObject(messages)
        }, /*#__PURE__*/ React.createElement(WrappedComponent, props));
    };
};
export default withIntl;

//# sourceMappingURL=withIntl.js.map